import { render, staticRenderFns } from "./CreditLimitViewTable.vue?vue&type=template&id=3c588da8"
import script from "./CreditLimitViewTable.vue?vue&type=script&lang=js"
export * from "./CreditLimitViewTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports